import React from 'react';
import { PlpContext } from '../../hooks/useCioPlpContext';
import useCioPlpProvider from '../../hooks/useCioPlpProvider';
export default function CioPlpProvider(props) {
    const { children, ...rest } = props;
    const contextValue = useCioPlpProvider(rest);
    return (React.createElement(PlpContext.Provider, { value: contextValue }, typeof children === 'function' ? children(contextValue) : children));
}
